import React from 'react';
import Analytics from 'utils/analytics';
import CommonValues from 'resources/common-values';

import CommonStrings from 'resources/common-strings';
import CreateReactClass from 'create-react-class';

export default CreateReactClass({
    shouldComponentUpdate(nextProps, nextState) {
        return false;
    },

    render() {
        return (
            <footer>
                <p key="copyright-confidentiality" className="footer-copyright">
                    {CommonStrings.copyright.confidentiality}
                </p>
                <p key="copyright-user-norm" className="footer-copyright">
                    {CommonStrings.copyright.userNormFooter}
                </p>
                <p key="copyright-text-lexile" className="footer-copyright">
                    {CommonStrings.copyright.lexile}
                </p>
                <span>
                    <a
                        data-testid="terms-of-use"
                        target="_blank"
                        href="https://www.nwea.org/policy/nwea-platform-terms-of-use/"
                        key="terms-of-use"
                        className="screen-only terms-of-use"
                        onClick={() => {
                            Analytics.recordButtonClick(CommonValues.SectionIDs.footer, 'terms-of-use');
                        }}
                    >
                        Terms of Use
                    </a>
                    <span>&ndash;</span>
                    <a
                        data-testid="privacy-policy"
                        target="_blank"
                        href="https://www.nwea.org/privacy-and-terms/"
                        key="privacy-policy-link"
                        className="screen-only"
                        onClick={() => {
                            Analytics.recordButtonClick(CommonValues.SectionIDs.footer, 'privacy-policy');
                        }}
                    >
                        Privacy Policy
                    </a>
                </span>
                <span key="nwea-logo" className="icon icon-nweaGraphite" />
                <div className="instructional-areas-copyright print-only">
                    <p key="copyright-text" >
                        {CommonStrings.copyright.copyrightText}
                    </p>
                    <p key="copyright-text-commonCore">
                        {CommonStrings.copyright.commonCore}
                    </p>
                    <p key="copyright-text-science">
                        {CommonStrings.copyright.science}
                    </p>
                    <p key="copyright-text-columbiaText">
                        {CommonStrings.copyright.columbiaText}
                    </p>
                    <div key="copyright-text-virginiaText">
                        {CommonStrings.copyright.virginiaText.split('\n').map((line, index) => (
                            <p key={`virginia-line-${index}`}>{line}</p>
                        ))}
                        <ul>
                            <li>
                                {CommonStrings.copyright.virginiaBulletPoint1}
                            </li>
                            <li>
                                {CommonStrings.copyright.virginiaBulletPoint2}
                            </li>
                            <li>
                                {CommonStrings.copyright.virginiaBulletPoint3}
                            </li>
                        </ul>
                        {CommonStrings.copyright.virginiaText1.split('\n').map((line, index) => (
                            <p key={`virginia-line-${index}`}>{line}</p>
                        ))}
                        <ul>
                            <li>
                                {CommonStrings.copyright.virginiaBulletPoint1}
                            </li>
                            <li>
                                {CommonStrings.copyright.virginiaBulletPoint2}
                            </li>
                            <li>
                                {CommonStrings.copyright.virginiaBulletPoint3}
                            </li>
                        </ul>
                    </div>
                </div>
            </footer>
        );
    },
});